@if (fallbackMessage$()) {
  <div class="sol-view-host-fallback">{{ fallbackMessage$() }}</div>
} @else {
  <ng-container #view />
}
